module.exports = __webpack_public_path__ + "static/media/fire3.13acfdb1.svg";